import { useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import BaseButton from '../../components/BasicComponent/BaseButton'
import FixedBottom from '../../components/BasicComponent/FixedBottom'
import AutomatedTrafficFineNotificationVehicleList from './components/automatedTrafficFineNotificationVehicleList'
import AutomatedTrafficFineNotificationStep from '../../components/FeaturesComponent/automatedTrafficFineNotificationStep'
import HeaderPartner from '../../components/FeaturesComponent/headerPartner'
import LayoutPartner from '../../components/FeaturesComponent/layoutPartner'
import { PATH } from '../../constants/router'
import appUserService from '../../services/appUserService'
import { useVehicleList } from '../../hooks/useVehicleList'
import AutomatedTrafficFineNotificationErrorModal from '../../components/FeaturesComponent/automatedTrafficFineNotificationErrorModal'
import './index.scss'

export default function AutomatedTrafficFineNotificationVehicles() {
  const history = useHistory()
  const location = useLocation()
  const selectedServices = location.state?.services || []
  const email = location.state?.email

  const phoneNumber = typeof window !== 'undefined' ? sessionStorage.getItem('phoneNumber') || '' : ''

  const maxVehicles = parseInt(selectedServices[0]?.productSize) || 1

  const [selectedVehicles, setSelectedVehicles] = useState([])
  const [errorMessage, setErrorMessage] = useState('')

  const { vehicles, isLoading, setVehicles, addVehicleToList } = useVehicleList(phoneNumber)

  const isSingleMode = maxVehicles === 1

  const handleSelectVehicle = (vehicle) => {
    const id = vehicle.id
    if (isSingleMode) {
      // Single mode: just add to selectedVehicles, don't fill input
      const isSelected = selectedVehicles.some((v) => v.id === id && v.source === 'list')

      if (isSelected) {
        setSelectedVehicles(selectedVehicles.filter((v) => !(v.id === id && v.source === 'list')))
      } else {
        setSelectedVehicles([
          {
            id: vehicle.id,
            plate: vehicle.plate,
            vehicleType: vehicle.vehicleType,
            source: 'list'
          }
        ])
      }
    } else {
      // Multi mode: existing logic
      const isSelected = selectedVehicles.some((v) => v.id === id && v.source === 'list')

      if (isSelected) {
        setSelectedVehicles(selectedVehicles.filter((v) => !(v.id === id && v.source === 'list')))
      } else if (selectedVehicles.length < maxVehicles) {
        setSelectedVehicles([
          ...selectedVehicles,
          {
            id: vehicle.id,
            plate: vehicle.plate,
            vehicleType: vehicle.vehicleType,
            source: 'list'
          }
        ])
      }
    }
  }

  const handleDeleteVehicle = async (vehicle) => {
    const id = vehicle.id
    // Lấy token từ session
    if (vehicle?.activeNotifyPackageIndex >= 0 && vehicle?.customerSchedule?.[vehicle.activeNotifyPackageIndex]) {
      setErrorMessage({ title: 'Không thể xoá xe', content: 'Xe đang có gói thông báo còn hiệu lực. Vui lòng không xoá xe.' })
      return true
    }
    const session = JSON.parse(localStorage.getItem('bhxm:notification:user_session:v1') || 'null')
    if (!session?.token) {
      setErrorMessage({ title: 'Xóa xe thất bại', content: 'Không thể xác thực. Vui lòng đăng nhập lại.' })
      return
    }

    try {
      const result = await appUserService.deleteVehicle(id, session.token)
      if (result.statusCode === 200) {
        setVehicles((s) => s.filter((v) => v.id !== id))
        // Xóa xe từ selectedVehicles nếu có
        setSelectedVehicles(selectedVehicles.filter((v) => !(v.id === id && v.source === 'list')))
      } else {
        if (result?.error === 'ERROR_NOTIFY_PACKAGE_STILL_ACTIVE') {
          setErrorMessage({ title: 'Không thể xoá xe', content: 'Xe đang có gói thông báo còn hiệu lực. Vui lòng không xoá xe.' })
        } else {
          setErrorMessage({ title: 'Xóa xe thất bại', content: 'Không thể xóa xe. Vui lòng thử lại.' })
        }
      }
    } catch (error) {
      setErrorMessage({ title: 'Xóa xe thất bại', content: 'Có lỗi xảy ra khi xóa xe. Vui lòng thử lại.' })
    }
  }

  const handleVehiclesChange = async (plateNumber, vehicleType, phoneNumber) => {
    if (vehicles.length >= 20) {
      setErrorMessage({ title: 'Thêm xe thất bại', content: 'Số lượng xe không được vượt quá 20. Vui lòng xóa bớt xe để tiếp tục.' })
      return { success: false }
    }

    const result = await addVehicleToList(plateNumber, vehicleType, phoneNumber)
    if (!result.success) {
      setErrorMessage({ title: 'Thêm xe thất bại', content: 'Không thể thêm xe. Vui lòng thử lại.' })
    }
    return result
  }

  const handleNextStep = () => {
    // Chỉ sử dụng xe đã chọn từ danh sách
    if (selectedVehicles.length === 0) return

    history.push(PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_PAYMENT, {
      services: selectedServices,
      vehicles: selectedVehicles,
      email: email
    })
  }

  // Calculate vehicle count
  const vehicleCount = selectedVehicles.length

  // Button disabled khi số xe đã chọn chưa đủ theo gói
  const isNextButtonDisabled = vehicleCount !== maxVehicles

  return (
    <LayoutPartner>
      <HeaderPartner title={'Tự động thông báo phạt nguội'} />
      <div className="AutomatedTrafficFineNotificationServices">
        <AutomatedTrafficFineNotificationStep step={1} />
        <div className="AutomatedTrafficFineNotificationServices-purpose">Chọn/ nhập {maxVehicles} phương tiện để tiếp tục</div>
        <AutomatedTrafficFineNotificationVehicleList
          vehicles={vehicles}
          selectedServices={selectedServices}
          selectedVehicles={selectedVehicles}
          maxVehicles={maxVehicles}
          phoneNumber={phoneNumber}
          isSingleMode={isSingleMode}
          isLoading={isLoading}
          onSelectVehicle={handleSelectVehicle}
          onDeleteVehicle={handleDeleteVehicle}
          onVehiclesChange={handleVehiclesChange}
        />
        <FixedBottom elementPaddingBottom={'LayoutPartner'}>
          <BaseButton onClick={handleNextStep} disabled={isNextButtonDisabled}>
            Tiếp theo
          </BaseButton>
        </FixedBottom>
      </div>

      <AutomatedTrafficFineNotificationErrorModal
        open={errorMessage}
        onClose={() => {
          setErrorMessage(null)
        }}
        title={errorMessage?.title || ''}
        content={errorMessage?.content || ''}
      />
    </LayoutPartner>
  )
}
